import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import find from 'lodash/find';
import slice from 'lodash/slice';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './BundleDimensions.css';

const cx = classNames.bind(styles);

/* istanbul ignore next */
class BundleDimensions extends Component {
    static defaultProps = {
        productDetails: {},
    };

    static propTypes = {
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    };

    dimensionsDetails(dimensionsDetails) {
        let dimensionData = null;
        try {
            dimensionData = {
                dimension1: { name: '', value: '' },
                dimension2: { name: '', value: '' },
                dimension3: { name: '', value: '' },
                dimension4: { name: '', value: '' },
                isDimensionAvailable: false,
            };
            if (dimensionsDetails && dimensionsDetails.data) {
                const dimensions = find(dimensionsDetails.data, { name: 'Dimensions' });
                const sliceDimensions = dimensions ? slice(dimensions.attributes, 0, 4) : '';
                dimensionData.dimension1 = sliceDimensions[0];
                dimensionData.dimension2 = sliceDimensions[1];
                dimensionData.dimension3 = sliceDimensions[2];
                dimensionData.dimension4 = sliceDimensions[3];
                dimensionData.isDimensionAvailable = true;
            }
        } catch (e) {
            console.error(e);
        }
        return dimensionData;
    }

    render() {
        const { productDetails } = this.props;
        const dimensionsDetails =
            productDetails && productDetails.lots && productDetails.lots.length
                ? productDetails.lots[0].specifications
                : null;
        const {
            dimension1,
            dimension2,
            dimension3,
            dimension4,
            isDimensionAvailable,
        } = this.dimensionsDetails(dimensionsDetails);
        const dimensionNameStyle = dt(['font-open-sans-bold', 'text-sm']);
        const productDimensionsStyle = dt([
            'mt-4',
            'mx-0',
            'mb-2',
            'font-open-sans-regular',
            'text-small',
        ]);
        return (
            <section>
                {isDimensionAvailable ? (
                    <div data-automation-id="productDimensions" className={productDimensionsStyle}>
                        <h4
                            className={dt(['font-open-sans-bold', 'text-normal', 'font-open-sans'])}
                        >
                            Dimensions
                        </h4>
                        {dimension1 ? (
                            <p>
                                <span
                                    data-automation-id="dimensionName"
                                    className={dimensionNameStyle}
                                >
                                    {dimension1.name}
                                </span>
                                <span> {dimension1.value}</span>
                            </p>
                        ) : (
                            ''
                        )}
                        {dimension2 ? (
                            <p>
                                <span
                                    data-automation-id="dimensionName"
                                    className={dimensionNameStyle}
                                >
                                    {dimension2.name}
                                </span>
                                <span> {dimension2.value}</span>
                            </p>
                        ) : (
                            ''
                        )}
                        {dimension3 ? (
                            <p>
                                <span
                                    data-automation-id="dimensionName"
                                    className={dimensionNameStyle}
                                >
                                    {dimension3.name}
                                </span>
                                <span> {dimension3.value}</span>
                            </p>
                        ) : (
                            ''
                        )}
                        {dimension4 ? (
                            <p>
                                <span
                                    data-automation-id="dimensionName"
                                    className={dimensionNameStyle}
                                >
                                    {dimension4.name}
                                </span>
                                <span> {dimension4.value}</span>
                            </p>
                        ) : (
                            ''
                        )}
                    </div>
                ) : (
                    ''
                )}
            </section>
        );
    }
}

export default BundleDimensions;
